import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCChartRadarChart, RCCGrid, RCCHookToast, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import List from "src/components/List";
import Modal from "src/components/Modal";
import ModalSide from "src/components/Modal/styles";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import Loader from "src/components/Loader";
import formatNumber from "src/utils/formatNumber";
import { IMatba001Form, IMatba002 } from "../interface";

export interface IRefModalRadarChart{
	openModal: (row: IMatba001Form, onCallbackFunction?: Function) => void;
  }

const ModalRadarChart: React.ForwardRefRenderFunction<IRefModalRadarChart> = (_, ref) => {

	const { translate, currentLanguage } = useTranslation();
	const { addToast } = RCCHookToast();

	const [analysis, setAnalysis] = useState<IMatba001Form>({} as IMatba001Form);
	const [level1, setLevel1] = useState<IMatba002[]>();
	const [loading, setLoading] = useState(true);

	const modalAddOrChange = useRef<RCCRefModalProps>(null);

	const openModal = async (row: IMatba001Form) => {	
		setAnalysis(row);
		queryLevel1Data(row.maa001Id);
		modalAddOrChange.current?.openModal();
	};

	const queryLevel1Data = async (id: number) => {
		try{
			setLoading(true);
			const { data } = await RCCServicesApi.getRequest({
				method: "Analysis/ListLevel1",
				urlParameters: {
					id
				}
			});

			setLevel1(data);
			modalAddOrChange.current?.openModal();
			setLoading(false);
		}catch(err){
			standardErrorMessages(err, translate("Erro ao carregar dados do gráfico"), addToast);
		}
	};

	useImperativeHandle(ref, () => ({
		openModal
	}));

	const dataAnalysis = () => { 
		const criteria: any = [];
		level1?.forEach((matba002: IMatba002) => {
			const criteriaObject: any = [];
			criteriaObject.name = matba002.maa002Descricao;
			criteriaObject.Analysis =  matba002.chartEvaluation;
			criteria.push(criteriaObject);
		});
		return criteria;
	};

	const dataChart = dataAnalysis();

	const dataRadar = [
		{
			dataKey: "Analysis",
			name: analysis.maa001Titulo
		}	
	];

	return (
		<>		
			<Modal
				ref={modalAddOrChange}
				header={{
					title: `${translate("Gráfico Análise")}`,
					subtitle: `${translate("Análise")}: ${analysis.maa001Titulo}`,
					icon: {
						name: "chartBar"
					}
				}}
				styleInline={ModalSide}
				footer={{
					showSaveButton: false,
					cancelButtonText: translate("Fechar")
				}}
			>
				{
					loading ? 
						<Loader />
						: 
						<>
							<RCCGrid
								container
								item
								style={{ height: "400px" }}
							>
								<RCCChartRadarChart 
									width={500}
									height={400}
									data={[...dataChart]}	
									radar={dataRadar}	 		
								/>
							</RCCGrid>
							<RCCGrid style={{marginTop: 10}}>
								<List 
									showHeader
									data={level1 || []}
									columns={[{
										idColumn: "maa002Descricao",
										nameColumn: translate("Critério"),
										xs: 12,
										sm: 6,
										justify: "left",
										truncate: true
									},{
										idColumn: "chartEvaluation",
										nameColumn: translate("Avaliação"),
										xs: 12,
										sm: 2,
										justify: "left",
										cellRenderer: (row: any) => formatNumber(row.chartEvaluation, currentLanguage, 2)
									}]}
									layout="table"
								/>
							</RCCGrid>
						</>
				}
				
			</Modal>
		</>
	);
};

export default forwardRef(ModalRadarChart);
